<script lang="ts">
	// @ts-nocheck
	import { _ } from 'svelte-i18n';

	import { getHubStores } from '$lib/stores/hubStores';

	import './style/table.css';

	import Icon from '$lib/components/Icon/Icon.svelte';
	import Loader from '$lib/components/Loader/Loader.svelte';
	import MobileColumSelector from '$lib/components/headerBar/performance/tables/MobileColumnSelector.svelte';

	import type { HubMetricsInterface, PerformanceEnagegmentInterface } from '$lib/api/restApi';
	import type { SelectedDate } from '$lib/types/SelectedDate';
	import { toastMessages } from '$lib/stores/toastMessageStore';

	let loading = true;

	const { hub, restApi } = getHubStores();

	let dataHub: HubMetricsInterface[];
	let dataEngagement: PerformanceEnagegmentInterface;

	export let callback: (title: string, author: string, id: string, status: string) => void;

	export let selectedDate: SelectedDate;

	type sorting = 'total_views' | 'like_count' | 'comment_count';

	const fetchHubPosts = async (
		limit?: number,
		order_by?: sorting,
		from_highest?: boolean,
		start?: Date,
		end?: Date
	) => {
		loading = true;
		const resp = await restApi.fetchPerformancePagePosts(
			$hub.id,
			limit,
			order_by,
			from_highest,
			start,
			end
		);
		if (resp.status === 200) {
			dataHub = resp.data;
			itemCount = dataHub.length;
		} else {
			toastMessages.danger('', resp.error);
		}
		loading = false;
	};

	const fetchHubEnagegement = async (start?: Date, end?: Date) => {
		const resp = await restApi.fetchPerformancePageEnagegement($hub.id, start, end);
		if (resp.status === 200) {
			dataEngagement = resp.data;
		} else {
			toastMessages.danger('', resp.error);
		}
		loading = false;
	};

	let currentOrder: sorting = 'total_views';
	let order: Record<string, boolean> = {
		total_views: true,
		comment_count: true,
		like_count: true,
	};

	let itemCount: number;
	let limit = 20;

	let tableElement: HTMLElement;
	const loadOnScroll = () => {
		if (tableElement.scrollTop >= tableElement.scrollHeight - 500) {
			if (itemCount < limit) {
				return;
			}
			limit = limit + 100;
		}
	};

	$: void fetchHubPosts(
		limit,
		currentOrder,
		order[currentOrder],
		selectedDate?.start,
		selectedDate?.end
	);
	$: void fetchHubEnagegement(selectedDate?.start, selectedDate?.end);
</script>

{#if dataHub && dataEngagement && dataHub.length > 0}
	<div
		on:scroll={loadOnScroll}
		bind:this={tableElement}
		class="performance-table scroll"
		id="performance-table">
		<table>
			<thead>
				<tr class="desktop-table">
					<th>{`${$_('performance.modal.headers.posts')} (${dataEngagement.posts.engagement})`}</th>
					<th
						><div>
							{`${$_('performance.modal.headers.views')} (${dataEngagement.total_views})`}
							<Icon
								onClick={() => {
									order['total_views'] = !order['total_views'];
									currentOrder = 'total_views';
								}}
								icon="switch"
								size="20" />
						</div></th>
					<th
						><div>
							{`${$_('performance.modal.headers.contributions')} (${dataEngagement.comment_count})`}
							<Icon
								onClick={() => {
									order['comment_count'] = !order['comment_count'];

									currentOrder = 'comment_count';
								}}
								icon="switch"
								size="20" />
						</div></th>
					<th
						><div>
							{`${$_('performance.modal.headers.likes')} (${dataEngagement.like_count})`}
							<Icon
								onClick={() => {
									order['like_count'] = !order['like_count'];

									currentOrder = 'like_count';
								}}
								icon="switch"
								size="20" />
						</div></th>
				</tr>
				<tr class="mobile-table">
					<th>{`${$_('performance.modal.headers.posts')} (${dataEngagement.posts.engagement})`}</th>
					{#if currentOrder === 'total_views'}
						<th
							><div class="header-cell-switch">
								{`${$_('performance.modal.headers.views')} (${dataEngagement.total_views})`}
							</div></th>
					{:else if currentOrder == 'comment_count'}
						<th
							><div class="header-cell-switch">
								{`${$_('performance.modal.headers.contributions')} (${
									dataEngagement.comment_count
								})`}
							</div></th>
					{:else if currentOrder == 'like_count'}
						<th
							><div class="header-cell-switch">
								{`${$_('performance.modal.headers.likes')} (${dataEngagement.like_count})`}
							</div></th>
					{/if}
				</tr>
			</thead>
			<tbody class="desktop-table">
				{#each dataHub as post}
					<tr>
						<td>
							<div class="main-column">
								<a
									on:click|preventDefault={() =>
										callback(
											post.title ? post.title : $_('performance.untitled'),
											$_('performance.posted.by').replace('{user}', post.user.name),
											post.id,
											post.status
										)}
									href="a">{post.title ? post.title : $_('performance.untitled')}</a
								><span>{$_('performance.by').replace('{user}', post.user.name)}</span>
							</div>
						</td>
						<td>{post.total_views}</td>
						<td>{post.comment_count}</td>
						<td>{post.like_count}</td>
					</tr>
				{/each}
				<Loader {loading} />
			</tbody>
			<tbody class="mobile-table">
				{#each dataHub as post}
					<tr>
						<td>
							<div class="main-column">
								<a
									on:click|preventDefault={() =>
										callback(
											post.title ? post.title : $_('performance.untitled'),
											$_('performance.posted.by').replace('{user}', post.user.name),
											post.id,
											post.status
										)}
									href="a">{post.title ? post.title : $_('performance.untitled')}</a
								><span>{$_('performance.by').replace('{user}', post.user.name)}</span>
							</div>
						</td>
						{#if currentOrder === 'total_views'}
							<td>{post.total_views}</td>
						{:else if currentOrder == 'comment_count'}
							<td>{post.comment_count}</td>
						{:else if currentOrder == 'like_count'}
							<td>{post.like_count}</td>
						{/if}
					</tr>
				{/each}
				<Loader {loading} />
			</tbody>
		</table>
	</div>
{:else}
	<div class="performance-table">
		<table>
			<thead>
				<tr class="desktop-table">
					<th>{`${$_('performance.modal.headers.users')} (0)`}</th>
					<th>{`${$_('performance.modal.headers.views')} (0)`}</th>
					<th>
						{`${$_('performance.modal.headers.contributions')} (0)`}
					</th>
					<th>
						{`${$_('performance.modal.headers.likes')} (0)`}
					</th>
				</tr>
				<tr class="mobile-table">
					<th>{`${$_('performance.modal.headers.users')} (0)`}</th>
					{#if currentOrder === 'total_views'}
						<th>
							{`${$_('performance.modal.headers.views')} (0)`}
						</th>
					{:else if currentOrder == 'comment_count'}
						<th>
							{`${$_('performance.modal.headers.contributions')} (0)`}
						</th>
					{:else if currentOrder == 'like_count'}
						<th>
							{`${$_('performance.modal.headers.likes')} (0)`}
						</th>
					{/if}
				</tr>
			</thead>
		</table>
	</div>
	<h3 class="empty">{$_('performance.hub.metrics.empty')}</h3>
{/if}
<div class="mobile-table">
	<div class="mobile-column-selector">
		<MobileColumSelector
			onChange={(column) => {
				if (column === 0) {
					currentOrder = 'total_views';
				} else if (column === 1) {
					currentOrder = 'comment_count';
				} else if (column === 2) {
					currentOrder = 'like_count';
				}
			}} />
	</div>
</div>
